import { gql } from "@apollo/client"
// Type Definitions

// Fragments
const VARIETY_FRAGMENTS = {
  varietyDetails: gql`
    fragment VarietyDetailsFrag on CommodityVarietyType {
      id
      name
      standardDeduction
      estimatedProduce
      preferredSku {
        id
        name
      }
      primaryGroup {
        id
        name
      }
      commodity {
        id
        name
      }
      harvestGrades {
        id
        name
        specifications
      }
      preferredCertification {
        id
        name
      }
      qualityParameters {
        id
        name
        standard
        valueType
        parameterType
        dropdownValues
      }
      groups {
        id
        name
      }
    }
  `,
  varietyList: gql`
    fragment VarietyListFrag on CommodityVarietyType {
      id
      name
      createdAt
      groups {
        id
        name
      }
      primaryGroup {
        id
        name
        codename
      }
      commodity {
        id
        name
      }
      harvestGrades {
        id
        name
      }
    }
  `,
}

// Queries
const VARIETY_LIST = gql`
  query allVarietiesList($query: String, $first: Int, $skip: Int) {
    allVarieties(query: $query, first: $first, skip: $skip) {
      ...VarietyListFrag
    }
  }
  ${VARIETY_FRAGMENTS.varietyList}
`

const VARIETY_DETAILS = gql`
  query varietyDetails($id: Int) {
    varietyDetails(varietyId: $id) {
      ...VarietyDetailsFrag
    }
  }
  ${VARIETY_FRAGMENTS.varietyDetails}
`

// Mutations

const ADD_UPDATE_CROP_VARIETY = gql`
  mutation addUpdateCropVariety(
    $id: Int
    $commodity: Int
    $groups: [Int]
    $harvestGrades: [HarvestGradeInput]
    $name: String
    $preferredSku: Int
    $preferredCertification: Int
    $estimatedProduce: Float
    $qualityParameters: [QualityParameterInput]
    $standardDeduction: Float
    $primaryGroupId: ID
  ) {
    addUpdateCropVariety(
      id: $id
      commodity: $commodity
      groups: $groups
      harvestGrades: $harvestGrades
      name: $name
      estimatedProduce: $estimatedProduce
      preferredSku: $preferredSku
      preferredCertification: $preferredCertification
      qualityParameters: $qualityParameters
      standardDeduction: $standardDeduction
      primaryGroupId: $primaryGroupId
    ) {
      variety {
        ...VarietyDetailsFrag
      }
    }
  }
  ${VARIETY_FRAGMENTS.varietyDetails}
`
export {
  VARIETY_LIST,
  VARIETY_FRAGMENTS,
  VARIETY_DETAILS,
  ADD_UPDATE_CROP_VARIETY as ADD_UPDATE_VARIETY,
}
